import React, { useState, useEffect } from "react";
import { getUserId, getAccesstoken } from "../../utils/auth";
import { fetchCartAndItems, createOrder, handleCheckoutProcess } from "../../api/ShopHelper";
import Modal from "../Shared/Modal";
import { useNavigate } from "react-router-dom";


const OrderSummary = ({ 
  fullname, 
  email, 
  mobile, 
  streetAddress,
  state,
  shipping_state_code,
  pincode,
  billing_streetAddress,
  billing_state,
  billing_pincode,
  billing_fullname,
  billing_email,
  billing_mobile,
  billing_state_code,
  billing_gst,
  isProcessing,
  setIsProcessing,
  onOrderSuccess,
  onOrderError
}) => {
  const [cart, setCart] = useState([]);
  const [showOrderSuccess, setShowOrderSuccess] = useState(false);
  const user_id = getUserId();
  const access_token = getAccesstoken();
  const navigate = useNavigate();

  useEffect(() => {
    if (access_token && user_id) {
      fetchCartItems();
    }
  }, [access_token, user_id]);

  const fetchCartItems = async () => {
    const { cartItems } = await fetchCartAndItems(user_id, access_token);
    setCart(cartItems);
  };

  const handleOrderComplete = () => {
    // Remove any lingering backdrop
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    // Remove modal-open class from body
    document.body.classList.remove('modal-open');
    // Reset any inline styles added to body
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
    // Navigate to orders page
    navigate('/user/orders');
  };

  const handlePlaceOrder = async () => {
    if (!fullname || !email || !mobile || !streetAddress || !state || !pincode) {
      onOrderError("Please fill in all required fields");
      return;
    }

    setIsProcessing(true);
    try {
      // Combine address fields into a formatted address string
      const formattedAddress = `${streetAddress}, ${state}, ${pincode}`.trim();
      const formattedBillingAddress = `${billing_streetAddress}, ${billing_state}, ${billing_pincode}`.trim();

      const orderData = {
        user_id: user_id,
        total_amount: parseFloat(totalAmount),
        order_status: "initiated",
        shipping_address: formattedAddress,
        billing_address: formattedBillingAddress,
        payment_id: null,
        created_at: new Date().toISOString(),
        full_name: fullname,
        mobile: mobile,
        email: email,
        payment_mode: "ONLINE",
        cart_id: cart[0]?.cart_id,
        billing_fullname: billing_fullname,
        billing_email: billing_email,
        billing_mobile: billing_mobile,
        billing_state_code: billing_state_code,
        shipping_state_code: shipping_state_code,
        billing_gst: billing_gst,
      };

      console.log(orderData);

      const checkoutResponse = await handleCheckoutProcess(orderData, access_token);
      console.log(checkoutResponse);
    } catch (error) {
      setIsProcessing(false);
      onOrderError(error.message);
    }
  };

  const totalAmount = cart.reduce((acc, item) => acc + item.quantity * (item.unit_price || 0), 0).toFixed(2);

  return (
    <div className="col-lg-4">
      <div className="right-side-summery-box">
        <div className="summery-box-2">
          <div className="summery-header">
            <h3>Order Summary</h3>
          </div>
          <ul className="summery-contain">
            {cart.map((item) => (
              <li key={item.productId}>
                
                  <img
                    src={`../assets/images/products/${item.productDetails?.product_image || item.image_path}`}
                    alt={item.productDetails?.product_image || item.image_path}
                    className="checkout-image"
                    style={{ width: "50px", height: "50px", objectFit: "cover" }}
                  />
            
                <h4>
                  {item.productDetails?.name || "Product"} <span>X {item.quantity}</span>
                </h4>
                <h4 className="price">₹ {(item.quantity * item.unit_price).toFixed(2)}</h4>
              </li>
            ))}
          </ul>
          <ul className="summery-total">
            <li>
              <h4>Total</h4>
              <h4 className="price">₹ {totalAmount}</h4>
            </li>
          </ul>
        </div>
        <button
          className="btn text-white w-100 mt-4 fw-bold"
          style={{
            backgroundColor: "#75c043",
            fontWeight: "bold",
          }}
          onClick={handlePlaceOrder}
          disabled={isProcessing}
        >
          {isProcessing ? 'Processing...' : 'Place Order'}
        </button>
        {/* <OrderSuccess show={showModal} onClose={() => setShowModal(false)} /> */}
      </div>

      {showOrderSuccess && (
        <Modal
          title="Order Placed!"
          modalType="success"
          bodyText="Your order has been placed successfully!"
          modalId="orderSuccessModal"
          onClose={() => {
            setShowOrderSuccess(false);
            handleOrderComplete();
          }}
        />
      )}
    </div>
  );
};

export default OrderSummary;
